import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { Filters, mergeFilters } from "@/lib/filters";
import { FetchListRequest } from "@/services/api";
import { StoreProjectAssigneesService } from "@/services/storeProjectAssignees";
import { StoreProjectAssigneeListItem } from "@/types/storeProjectAssignees";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useStoreProjectAssigneeListQuery = ({
  enabled = true,
  filters: filtersFromProps,
}: {
  enabled?: boolean;
  filters?: Filters<StoreProjectAssigneeListItem>;
} = {}) => {
  const name = "storeProjectAssignees";
  const options = useCreateDataTableOptions<StoreProjectAssigneeListItem>(name);
  const fetchList = (
    fetchParams: FetchListRequest<StoreProjectAssigneeListItem>,
  ) => {
    return StoreProjectAssigneesService.getList(fetchParams);
  };

  const filters = useMemo(
    () => mergeFilters(options.filters, filtersFromProps),
    [filtersFromProps, options.filters],
  );

  const queryKey = useDynamicQueryParams(name, options);
  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      fetchList({
        lastItem: pageParam,
        filters,
        sorting: options.sorting[0],
      }),
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
  });

  return {
    query,
    options,
  };
};
